import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RentersVehicleInquiryScreen from "../../../container/Renters/RentersVehicleInquiryScreen";
import CreateRentersVehicleInquiry from "../../../container/Renters/RentersVehicleInquiryScreen/CreateRentersVehicleInquiry";


const RentersVehicleInquiryRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RENTERS_VEHICLEINQUIRY.HOME}
          element={
            <RentersVehicleInquiryScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RENTERS_VEHICLEINQUIRY.CREATE}
          element={<CreateRentersVehicleInquiry />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RENTERS_VEHICLEINQUIRY.EDIT}
          element={<CreateRentersVehicleInquiry isEdit={true} />}
        />
      )}
    </>
  );
};

export default RentersVehicleInquiryRoutes;
